import { FilterableMatTableDataSource } from './filterable-mat-table-data-source';

import { EmailTemplate } from '../models';

export class EmailTemplateDatasource extends FilterableMatTableDataSource<EmailTemplate> {}
